import React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

import MappingPresentationPane from '../../../containers/mapping/manual/PresentationPane';
import MappingUpdatePane from '../../../containers/mapping/manual/UpdatePane';
import SimpleNavigationBar from '../../navigation/SimpleNavigationBar';

const StyledMappingManualView = styled.div`
  height: calc(100% - 63px);

  .mapping-manual-view-wrapper {
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
`;

const MappingManualView = ({ updating, fetching, update }) => (
  <>
    <SimpleNavigationBar />
    <StyledMappingManualView>
      <Spin spinning={updating || fetching} size="large">
        <div className="mapping-manual-view-wrapper">
          {update ? <MappingUpdatePane /> : <MappingPresentationPane />}
        </div>
      </Spin>
    </StyledMappingManualView>
  </>
);

export default MappingManualView;
